const AVG_BLOCK_TIME_MS = 12 * 1000; // 12 seconds in milliseconds

// Reference block number and times from bitframes-randao/fetch-block-refs.js
const REFERENCE = {
  networks: {
    sepolia: {
      blockNumber: 7121868,
      timestamp: 1732183128000,
    },
    mainnet: {
      blockNumber: 21235362,
      timestamp: 1732183127000,
    },
  },
  timestamp: 1732183138579,
};

// Given a date, predict its block number
export function predictBlock(date, network = "mainnet", reference = REFERENCE) {
  const ref = reference.networks[network];
  // Reference block number and its corresponding timestamp (in milliseconds)
  const refBlockNumber = ref.blockNumber;
  const refTimestamp = ref.timestamp;

  // Convert the input date to a timestamp (in milliseconds)
  const targetTimestamp = new Date(date).getTime();

  // Calculate the time difference in milliseconds
  const timeDifference = targetTimestamp - refTimestamp;

  // Calculate the difference in blocks
  const blockDifference = Math.round(timeDifference / AVG_BLOCK_TIME_MS);

  // Estimate the block number
  const estimatedBlockNumber = refBlockNumber + blockDifference;

  return estimatedBlockNumber;
}

// Given a block number, predict its date
export function predictDate(
  blockNumber,
  network = "mainnet",
  reference = REFERENCE
) {
  const ref = reference.networks[network];
  // Reference block number and its corresponding timestamp (in milliseconds)
  const refBlockNumber = ref.blockNumber; // Approximate block number on October 1, 2023
  const refTimestamp = ref.timestamp; // Timestamp of reference block (ms)

  // Calculate the difference in blocks from the reference block
  const blockDifference = blockNumber - refBlockNumber;

  // Calculate the time difference in milliseconds
  const timeDifference = blockDifference * AVG_BLOCK_TIME_MS;

  // Estimate the timestamp of the target block
  const estimatedTimestamp = refTimestamp + timeDifference;

  // Return the estimated date as a JavaScript Date object
  return new Date(estimatedTimestamp);
}

// // Example usage:
// const targetBlockNumber = 20908527;
// const estimatedDate = predictTimestamp(targetBlockNumber, "mainnet");
// console.log(`Estimated Date: ${estimatedDate.toUTCString()}`);
